import { SR_API_ACTION_PROPERTY_ATTRIBUTE_GET_LIST } from 'api/actionTypes';

export function getPropertyAttributeListKeyId({
  apartmentId,
  apartmentBuildingId,
  floorPlanId,
  partnerId,
  category,
}) {
  return [apartmentId, apartmentBuildingId, floorPlanId, partnerId, category].join('_');
}

export default async function getList(
  { state, apiClient },
  { apartmentId, apartmentBuildingId, floorPlanId, partnerId, category, forceRefresh },
) {
  const keyId = getPropertyAttributeListKeyId({
    apartmentId,
    apartmentBuildingId,
    floorPlanId,
    partnerId,
    category,
  });

  const statePath = ['propertyAttributes', 'listBy', keyId];
  if (state.get(statePath) && !forceRefresh) {
    return state.get(statePath);
  }

  return apiClient.postWithState({
    action: SR_API_ACTION_PROPERTY_ATTRIBUTE_GET_LIST,
    state: state,
    payload: {
      apartmentId,
      apartmentBuildingId,
      floorPlanId,
      partnerId,
      category,
    },
    onSuccess(floorPlans) {
      state.set(statePath, floorPlans);
    },
  });
}
